'use client';

import classNames from 'classnames';
import { useState } from 'react';
import Translations from './i18n';
import Close from '$/components/icons/Close';
import Info from '$/components/icons/Info';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

type TISearchBannerProps = {
  message: string;
  /** Renders a dismiss affordance; the no-products state is permanent so omits it. */
  dismissible?: boolean;
  className?: string;
};

export function TISearchBanner({
  message,
  dismissible = false,
  className,
}: TISearchBannerProps): JSX.Element | null {
  const context = useClientContext();
  const staticText = getClientTranslations(Translations, context);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  return (
    <div
      role="status"
      className={classNames(
        className,
        'flex items-center gap-spacing/gap/x-xs rounded-radius/button px-spacing/padding/x-sm py-spacing/padding/y-xs bg-highlights/red-light text-highlights/red-dark',
      )}
    >
      <Info aria-hidden className="size-shapes/icon-size-md shrink-0" />
      <span className="mhg-alpha-typography-body-2 flex-1">{message}</span>
      {dismissible && (
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label={staticText.dismiss}
          className="flex size-shapes/icon-size-md shrink-0 items-center justify-center"
        >
          <Close className="size-full" />
        </button>
      )}
    </div>
  );
}
